<template>
    <a-modal :title="`${props.tableColumnsData.full_name} - 档案管理`" :width="1200" :open="true" @cancel="cancel">
        <template #footer>
            <div class="d-flex">
                <!-- 档案 Tab 才显示档案相关按钮 -->
                <template v-if="state.activeTab === 'archive'">
                    <template v-if="props.tableColumnsData.permission_show_zipzc == 1">
                        <div>
                            <!-- 设立的才能通过电子化账号获取章程 -->
                            <a-button :loading="state.downZcLoading"
                                v-if="props.tableColumnsData.main_type == 1 && props.tableColumnsData.registration_type != 2 && props.tableColumnsData.business_type == 1"
                                type="primary" @click="handleDownload">获取公司章程</a-button>
                            <a-button type="primary" @click="handleScreenshot" :loading="state.screenshotLoading"
                                v-if="props.tableColumnsData.permission_show_zipjd == 1">进度截图</a-button>
                        </div>
                    </template>
                    <template v-else>&nbsp;</template>
                    <div v-if="user.id == 1">
                        <a-form-item label="查询已删除档案" name="recycle">
                            <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="是" un-checked-children="否"
                                v-model:checked="state.recycle" @change="queryDetail"></a-switch>
                            <a-divider type="vertical" />
                            <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="正式合同"
                                un-checked-children="所有档案" v-model:checked="state.is_formal"
                                @change="queryDetail"></a-switch>
                        </a-form-item>
                    </div>
                </template>
                <!-- 仓库 Tab 时占位，保证取消按钮靠右 -->
                <template v-else>
                    <div></div>
                </template>

                <div>
                    <a-divider type="vertical" />
                    <a-button @click="cancel">取消</a-button>
                    <a-button type="primary" @click="handleRecord" v-if="state.activeTab === 'archive'">添加档案</a-button>
                </div>
            </div>
        </template>

        <a-tabs v-model:activeKey="state.activeTab">
            <!-- ==================== 档案管理 ==================== -->
            <a-tab-pane key="archive" tab="档案管理">
                <a-table size="small" :loading="state.ownershipTableLoading" style="margin-bottom: 30px"
                    :columns="columns" rowKey="id" :data-source="shareOwnership" :pagination="false">
                    <template #bodyCell="{ column, record, text }">
                        <template v-if="column.dataIndex == 'type_name'">
                            <div
                                :style="record.deleted_at ? { borderLeft: '5px dashed #000', paddingLeft: '10px' } : {}">
                                {{ text }}
                                <span v-if="record.is_formal == 1">【正式】</span>
                            </div>
                        </template>
                        <template v-else-if="column.dataIndex === 'check_status_name'">
                            <a-tag v-if="record.check_status == 1" color="orange">待审核</a-tag>
                            <a-tag v-else-if="record.check_status == 2" color="green">已审核</a-tag>
                            <a-tag v-else-if="record.check_status == 3" color="red">审核失败</a-tag>
                            <span v-else>-</span>
                        </template>
                        <template v-if="column.dataIndex === 'options'">
                            <div>
                                <a v-if="record.status == 2"
                                    :href="'/hncskaiyela/admin/v1/templateZipDown?id=' + record.id + '&token=' + token"
                                    target="_blank"> 下载</a>
                                <a-divider type="vertical" />
                                <a-popconfirm title="确定删除此档案?" @confirm="handleDelete(record)">
                                    <a style="color: red">删除</a>
                                </a-popconfirm>
                                <a-divider type="vertical" />
                                <a @click="handleTuiS(record)">推送</a>
                            </div>
                            <!-- 下载原始版本：仅超管显示 + 只针对 电子化资料(1)、现场资料(2)、银行开户资料(3)、租赁合同(4) -->
                            <div v-if="user.id == 1">
                                <a-popconfirm v-if="record.status == 2 && [1, 2, 3, 4].includes(Number(record.type))"
                                    :title="record.type_name" placement="left"
                                    @openChange="(e) => { openLeaseChange(e, record) }"
                                    @confirm="downLeaseLease(record)">
                                    <template #description>
                                        <a-form style="width: 480px; margin-top: 30px" v-bind="formLayout">
                                            <!-- 使用版本 -->
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="使用版本"
                                                required>
                                                <a-radio-group v-model:value="leaseData.versionType"
                                                    @change="onVersionTypeChange(record)">
                                                    <a-radio value="original">原始版本</a-radio>
                                                    <a-radio value="latest">最新版本</a-radio>
                                                    <a-radio value="other">其他模板</a-radio>
                                                </a-radio-group>
                                                <!-- 选中「其他模板」时展示可搜索下拉 -->
                                                <div v-if="leaseData.versionType === 'other'" style="margin-top: 8px">
                                                    <a-select show-search allow-clear style="width: 270px"
                                                        placeholder="输入名称/编号快捷搜索模板" v-model:value="leaseData.templateId"
                                                        option-filter-prop="label" :filter-option="filterTemplateOption"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                                                        <a-select-option v-for="t in otherTemplates" :key="t.id"
                                                            :value="t.id" :label="t.name + ' ' + t.template_code">
                                                            <div
                                                                style="display: flex; justify-content: space-between; gap: 12px">
                                                                <span>{{ t.name }}</span>
                                                                <span style="color: #999; font-size: 12px">{{
                                                                    t.template_code }}</span>
                                                            </div>
                                                        </a-select-option>
                                                    </a-select>
                                                </div>
                                            </a-form-item>

                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                label="是否盖公章" required>
                                                <a-radio-group v-model:value="leaseData.gz" @change="changeLeaseGz">
                                                    <a-radio :value="1"> 有公章 </a-radio>
                                                    <a-radio :value="2"> 无公章 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="是否签字"
                                                required>
                                                <a-radio-group v-model:value="leaseData.qz">
                                                    <a-radio :value="2"> 无签字 </a-radio>
                                                    <a-radio :value="1" v-if="leaseData.gz == 1"> 有签字 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                label="合同租金是否遮挡" required>
                                                <a-radio-group v-model:value="leaseData.zd">
                                                    <a-radio :value="1"> 遮挡 </a-radio>
                                                    <a-radio :value="2"> 未遮挡 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="租金"
                                                v-if="leaseData.zd == 2" required>
                                                <a-input v-model:value="leaseData.zujin" placeholder="请输入合同价格"
                                                    style="width: 150px" prefix="￥" suffix="元"> </a-input>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="入驻类型"
                                                required>
                                                <a-radio-group v-model:value="leaseData.fee_standard">
                                                    <a-radio :value="1"> 按年收费 </a-radio>
                                                    <a-radio :value="2"> 一次性收费 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                label="是否显示电话" required>
                                                <a-radio-group v-model:value="leaseData.tel">
                                                    <a-radio :value="2"> 不显示 </a-radio>
                                                    <a-radio :value="1"> 显示 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>

                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="租期"
                                                required>
                                                <a-select allow-clear v-if="leaseData.is_diy != 1" style="width: 250px"
                                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                    placeholder="请选择租期" v-model:value="leaseData.zqrange" required
                                                    @change="changzq">
                                                    <a-select-option :value="zqitem.start + '~' + zqitem.end"
                                                        v-for="zqitem in zqlist" :key="zqitem.start + zqitem.end">
                                                        {{ zqitem.start }}~{{ zqitem.end }}
                                                    </a-select-option>
                                                </a-select>
                                                <div v-if="leaseData.is_diy == 1">
                                                    <a-date-picker v-model:value="leaseData.zqrangea"
                                                        style="width: 120px" placeholder="租期开始日期"
                                                        :popupStyle="{ 'z-index': 9999 }"
                                                        @change="changzq" />~<a-date-picker
                                                        v-model:value="leaseData.zqrangeb" style="width: 120px"
                                                        placeholder="租期结束日期" :popupStyle="{ 'z-index': 9999 }" />
                                                </div>
                                                <a-switch
                                                    v-if="props.tableColumnsData.user_permission == 'admin' || props.tableColumnsData.user_permission == 'platform'"
                                                    :checkedValue="1" :unCheckedValue="2"
                                                    v-model:checked="leaseData.is_diy" checked-children="自定义"
                                                    un-checked-children="默认方式"></a-switch>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="理由"
                                                required>
                                                <a-select allow-clear style="width: 250px"
                                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                    placeholder="请选择理由" v-model:value="leaseData.reason" required>
                                                    <a-select-option value="仅供银行开户使用"> 仅供银行开户使用 </a-select-option>
                                                    <a-select-option value="其他"> 其他 </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                label="合同签订日期" required>
                                                <a-date-picker v-model:value="leaseData.hetong_sign_date"
                                                    style="width: 250px" placeholder="请选择合同签订日期"
                                                    :popupStyle="{ 'z-index': 9999 }" />
                                            </a-form-item>
                                        </a-form>
                                    </template>
                                    <a>下载原始版本</a>
                                </a-popconfirm>
                            </div>
                        </template>
                        <template v-else-if="column.dataIndex === 'url'">
                            <div v-if="[1, 2, 3, 5, 6, 7, 8, 12, 14, 21, 22, 23, 24, 25, 26].includes(record.type)"
                                class="image-list">
                                <template v-for="(item, index) in text">
                                    <b-image
                                        v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                                        :width="60" :height="60" :key="index"
                                        :src="$store.state.user.image_domain + item.url"></b-image>
                                    <b-file :href="$store.state.user.image_domain + item.url" v-else>
                                        {{ item.name }}
                                    </b-file>
                                </template>
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-else-if="column.dataIndex === 'remark'">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <span v-if="record.remark" style="font-size: 13px; word-break: break-all;">{{
                                    record.remark
                                }}</span>
                                <span v-else style="color: #ccc; font-size: 13px;">暂无备注</span>
                                <a style="font-size: 12px; white-space: nowrap;" @click="handleAddRemark(record)">添加</a>
                            </div>
                        </template>
                        <template v-else-if="column.dataIndex === 'operator_admin_info'">
                            {{ text?.nickname ? text.nickname : '-' }}
                        </template>
                    </template>
                </a-table>
            </a-tab-pane>

            <!-- ==================== 仓库管理 ==================== -->
            <a-tab-pane key="warehouse" tab="仓库管理">
                <div class="d-flex" style="margin-bottom: 12px;">
                    <div>
                        <a-button type="primary" @click="handleInOpen">入库</a-button>
                        <a-button danger style="margin-left: 8px;" :disabled="!state.selectedRowKeys.length"
                            @click="handleBatchOut">
                            出库（已选 {{ state.selectedRowKeys.length }} 项）
                        </a-button>

                        <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                            :cancel-button-props="{ size: 'middle' }" title="直接取走" placement="left"
                            @openChange="handleDirectTakeInit" @confirm="handleDirectTake()">
                            <template #description>
                                您确定执照已经直接取走了吗？货架号【{{ state.shelf_code }}】
                            </template>
                            <a-button style="margin-left: 8px;" type="primary">直接取走</a-button>
                        </a-popconfirm>
                    </div>
                    <div>
                        <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="在库" un-checked-children="全部"
                            v-model:checked="state.warehouseStatus" @change="queryWarehouse"></a-switch>
                    </div>
                </div>
                <a-table size="small" :loading="state.warehouseLoading" :columns="warehouseColumns" rowKey="id"
                    :row-selection="{ selectedRowKeys: state.selectedRowKeys, onChange: onSelectChange }"
                    :data-source="warehouseList" :pagination="false">
                    <template #bodyCell="{ column, record, text }">
                        <template v-if="column.dataIndex === 'status'">
                            <a-tag :color="record.status === 1 ? 'green' : 'default'">
                                {{ record.status === 1 ? '在库' : '已出库' }}
                            </a-tag>
                        </template>
                        <template v-else-if="column.dataIndex === 'options'">
                            <a v-if="record.status === 1" style="color: red" @click="handleOut(record)">出库</a>
                            <span v-else style="color: #ccc;">-</span>
                            <a-divider type="vertical" />
                            <a-popconfirm title="确定删除此仓库记录?" @confirm="handleWarehouseDelete(record)">
                                <a style="color: red">删除</a>
                            </a-popconfirm>
                        </template>
                        <template v-else-if="column.dataIndex === 'operator_admin_info'">
                            {{ text?.nickname ? text.nickname : '-' }}
                        </template>
                    </template>
                </a-table>
            </a-tab-pane>
        </a-tabs>

        <!-- 添加档案弹窗 -->
        <a-modal title="添加档案" :bodyStyle="{ padding: '20px', paddingBottom: '0' }" :width="700" :destroyOnClose="true"
            :open="state.createOpen" @ok="createOk" @cancel="
                () => {
                    state.createOpen = false
                }
            ">
            <a-form :model="createForm" v-bind="formLayout" ref="createFormRef">
                <a-form-item label="类型" required>
                    <a-select allow-clear v-model:value="createForm.type" placeholder="请选择档案类型">
                        <a-select-option v-for="(item, index) in typeList" :key="item.value">{{ item.label
                        }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="附件" required>
                    <Upload :upload_path="props.tableColumnsData.upload_path"
                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'm4a', 'mp4', 'mp3', 'amr', 'aac', 'wav', 'awb', '3ga', '3gp', 'wac', 'zip', 'rar', '7z']"
                        :customerName="props.tableColumnsData.entityNameToRegister.full_name" uploadType="text"
                        v-model:value="createForm.url" :limitation="99" uploadText="上传附件">
                    </Upload>
                </a-form-item>
                <a-form-item label="备注">
                    <a-input placeholder="请输入备注" v-model:value="createForm.remark"></a-input>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 添加备注弹窗 -->
        <a-modal title="添加备注" :width="500" :destroyOnClose="true" :open="state.remarkModalOpen" @ok="handleRemarkOk"
            @cancel="state.remarkModalOpen = false">
            <a-form :model="remarkForm" v-bind="formLayout">
                <a-form-item label="备注内容" required>
                    <a-textarea v-model:value="remarkForm.remark" :rows="4" placeholder="请输入备注内容"></a-textarea>
                    <div style="margin-top: 8px; display: flex; align-items: center; gap: 8px;">
                        <span style="color: rgba(0, 0, 0, 0.45); font-size: 14px; white-space: nowrap;">快捷输入：</span>
                        <a-button style="color: #389e0d; background: #f6ffed; border-color: #b7eb8f;"
                            @click="remarkForm.remark = '风控通过'">
                            风控通过
                        </a-button>
                        <a-button style="color: #cf1322; background: #fff1f0; border-color: #ffa39e;"
                            @click="remarkForm.remark = '风控失败'">
                            风控失败
                        </a-button>
                    </div>
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 变更的截图需要登录 -->
        <a-modal :title="`${props.tableColumnsData.full_name}变更登录`" :keyboard="false" :maskClosable="false" :width="800"
            :open="state.openQrcode" :footer="null" @cancel="qrcodeCancel">
            <a-form @finish="onRegisterFinish" v-bind="formLayout" :model="registerFormState" :rules="rules">
                <a-form-item label="核验方式">
                    <a-radio-group v-model:value="registerFormState.type" button-style="solid">
                        <a-radio :value="1" v-if="props.tableColumnsData.business_type == 2">短信验证码登录</a-radio>
                        <a-radio :value="2">授权登录</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="扫码登录" v-show="registerFormState.type == 2">
                    <div class="d-flex flex-left" v-show="state.deadline > 0">
                        <img :src="state.qrcode" />
                        <a-statistic-countdown format="mm:ss" title="登录倒计时" :value="state.deadline"
                            @finish="onStatisticFinish" />
                    </div>
                    <div v-show="state.deadline == 0">
                        <a-button type="primary" @click="handleScreenshot">重新获取</a-button>
                    </div>
                </a-form-item>
                <div v-if="registerFormState.type == 1">
                    <a-form-item label="统一社会信用代码" name="social_credit_code" required>
                        <a-input v-model:value="registerFormState.social_credit_code" placeholder="请输入统一社会信用代码">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="联络员姓名" name="name" required v-if="registerFormState.name">
                        <a-input v-model:value="registerFormState.name" :disabled="true"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员身份证号码" name="id_card_number" required>
                        <a-input v-model:value="registerFormState.id_card_number" placeholder="联络员身份证号码"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员电话号码" name="phone_number">
                        <a-input v-model:value="registerFormState.phone_number" placeholder="请输入联络员电话号码"
                            :disabled="true">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="验证码" required>
                        <div class="d-flex">
                            <a-input v-model:value="registerFormState.code" placeholder="请输入验证码"> </a-input><a-button
                                type="primary" class="ml-1x" @click="onGetCodeClick"
                                :disabled="state.getCodeDisabled">获取验证码</a-button>
                        </div>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ offset: 7, span: 16 }">
                        <a-button type="primary" html-type="submit">确定</a-button>
                    </a-form-item>
                </div>
            </a-form>
        </a-modal>

        <!-- 入库弹窗 -->
        <a-modal title="入库" :width="600" :destroyOnClose="true" :open="state.inOpen" @ok="inOk"
            @cancel="state.inOpen = false">
            <a-form :model="inForm" v-bind="formLayout" ref="inFormRef">
                <a-form-item label="物品名称" name="goods_name" required>
                    <a-input v-model:value="inForm.goods_name" placeholder="请输入入库物品名称" />
                </a-form-item>
                <a-form-item label="存储位置" name="storage_location" required>
                    <a-input v-model:value="inForm.storage_location" placeholder="如：A区-3排-2层" />
                </a-form-item>
                <a-form-item label="存储编号" name="storage_code" required>
                    <a-input v-model:value="inForm.storage_code" placeholder="请输入物品存储编号" />
                </a-form-item>
                <a-form-item label="备注">
                    <a-input v-model:value="inForm.remark" placeholder="请输入备注" />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 出库弹窗 -->
        <a-modal title="出库" :width="500" :destroyOnClose="true" :open="state.outOpen" @ok="outOk"
            @cancel="state.outOpen = false">
            <a-form :model="outForm" v-bind="formLayout">
                <a-form-item label="出库物品">
                    <span>{{ state.outGoodsNames }}</span>
                </a-form-item>
                <a-form-item label="出库备注">
                    <a-textarea v-model:value="outForm.out_remark" :rows="3" placeholder="请输入出库备注" />
                </a-form-item>
            </a-form>
        </a-modal>
    </a-modal>
</template>

<script lang="ts" setup>
import Upload from '@/components/base/Upload.vue'
import { reactive, onMounted, ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import ls from '@/utils/Storage'
import { useStore } from 'vuex'
import BImage from '@/components/sourceImg/BImage.vue'
import BFile from '@/components/sourceImg/BFile.vue'
import dayjs from 'dayjs'

const $store = useStore()
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const user = ls.get('USER_INFO')

interface tableData {
    isEdit: boolean
}

const emit = defineEmits(['cancel', 'callFatherDownLease'])

const columns: Array<Object> = [
    { title: '资料类型', dataIndex: 'type_name', width: 200 },
    { title: '资源', dataIndex: 'url', width: 350 },
    { title: '备注', dataIndex: 'remark', width: 250 },
    { title: '审核状态', dataIndex: 'check_status_name', width: 120 },
    { title: '创建时间', dataIndex: 'created_at', width: 180 },
    { title: '创建人', dataIndex: 'operator_admin_info', width: 180 },
    { title: '操作', dataIndex: 'options', width: 280 }
]

const warehouseColumns: Array<Object> = [
    { title: '物品名称', dataIndex: 'goods_name', width: 180 },
    { title: '存储位置', dataIndex: 'storage_location', width: 180 },
    { title: '存储编号', dataIndex: 'storage_code', width: 180 },
    { title: '状态', dataIndex: 'status', width: 90 },
    { title: '入库时间', dataIndex: 'in_time', width: 160 },
    { title: '出库时间', dataIndex: 'out_time', width: 160 },
    { title: '备注', dataIndex: 'remark', width: 180 },
    { title: '操作人', dataIndex: 'operator_admin_info', width: 120 },
    { title: '操作', dataIndex: 'options', width: 160 }
]

const typeList = [
    { label: '营业执照照片资料', value: 8 },
    { label: '章程资料', value: 9 },
    { label: '电子化资料', value: 1 },
    { label: '现场资料', value: 2 },
    { label: '租赁合同', value: 4 },
    { label: '银行开户资料', value: 3 },
    { label: '续费催款告知书', value: 5 },
    { label: '解除协议', value: 6 },
    { label: '移出异常资料', value: 7 },
    { label: '代理记账协议', value: 10 },
    { label: '列入异常资料', value: 11 },
    { label: '移交线索关店资料', value: 12 },
    { label: '刻章资料', value: 13 },
    { label: '进度截图', value: 14 },
    { label: '与财务公司的代理合同', value: 15 },
    { label: '电话录音', value: 25 },
    { label: '其他资料', value: 101 }
]

interface data {
    ownershipTableLoading: boolean
    downZcLoading: boolean
    createOpen: boolean
    screenshotLoading: boolean
    openQrcode: boolean
    qrcode: string
    deadline: number
    getCodeDisabled: boolean
    recycle: number
    is_formal: number
    remarkModalOpen: boolean
    activeTab: string
    warehouseLoading: boolean
    warehouseStatus: number
    selectedRowKeys: number[]
    inOpen: boolean
    outOpen: boolean
    outGoodsNames: string
    shelf_code: string
}

const state = reactive<data>({
    ownershipTableLoading: false,
    downZcLoading: false,
    createOpen: false,
    screenshotLoading: false,
    openQrcode: false,
    qrcode: '',
    deadline: 0,
    getCodeDisabled: false,
    recycle: 2,
    is_formal: 2,
    remarkModalOpen: false,
    activeTab: 'archive',
    warehouseLoading: false,
    warehouseStatus: 1,
    selectedRowKeys: [],
    inOpen: false,
    outOpen: false,
    outGoodsNames: '',
    shelf_code: ''
})

const createForm = reactive<any>({
    type: 8
})
const createFormRef = ref()
const inFormRef = ref()

const formLayout = {
    labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
    }
}

const shareOwnership = ref<tableData[]>([])

// 仓库相关
const warehouseList = ref<any[]>([])
const inForm = reactive<any>({
    goods_name: '',
    storage_location: '',
    storage_code: '',
    remark: ''
})
const outForm = reactive<any>({
    ids: [] as number[],
    out_remark: ''
})

// 备注相关
const remarkForm = reactive<any>({
    remark: '',
    id: null
})

/* ==================== 租赁合同 / 下载原始版本 参数配置 ==================== */
// 租期列表（由客户入驻时间构造）
const zqlist = ref<Array<{ start: string; end: string }>>([])

// 其他模板列表（可搜索）
const otherTemplates = ref<any[]>([])

// 构造租期列表（逻辑同 CustomerList 的 loadData）
const buildZqlist = (item: any) => {
    let list: Array<{ start: string; end: string }> = []
    if (!item || !item.enter_starttime) {
        return list
    }
    list.push({
        start: dayjs(item.enter_starttime).add(1, 'year').format('YYYY-MM-DD'),
        end: dayjs(item.enter_starttime).add(2, 'year').format('YYYY-MM-DD')
    })
    list.push({
        start: dayjs(item.enter_starttime).format('YYYY-MM-DD'),
        end: dayjs(item.enter_starttime).add(1, 'year').format('YYYY-MM-DD')
    })
    let startday = dayjs(item.created_at).startOf('day')
    let zqend = dayjs(item.enter_starttime)
    while (zqend.isAfter(startday)) {
        let zqstart = zqend.subtract(1, 'year')
        if (zqstart.isBefore(startday)) {
            zqstart = startday
        }
        list.push({
            start: zqstart.format('YYYY-MM-DD'),
            end: zqend.format('YYYY-MM-DD')
        })
        zqend = zqstart
    }
    list.reverse()
    return list
}

const leaseData = reactive({
    // ===== 使用版本相关 =====
    versionType: 'original', // original | latest | other
    templateId: null, // 选择"其他模板"时的模板 id

    gz: 2,
    qz: 2,
    zd: 1,
    tel: 2,
    zujin: null,
    zqrange: '',
    zqrangea: null,
    zqrangeb: null,
    is_diy: 2,
    reason: '仅供银行开户使用',
    fee_standard: 1,
    hetong_sign_date: dayjs(dayjs().format('YYYY-MM-DD'), 'YYYY-MM-DD'),
    last_company_id: 0
})

// 从 record 中获取版本列表（接口返回 record.versions，若无则用单条兜底）
const getVersions = (record: any) => {
    if (record && Array.isArray(record.versions) && record.versions.length > 0) {
        return record.versions
    }
    return [
        {
            id: record.id,
            version: 1,
            name: '原始版本',
            created_at: record.created_at,
            is_latest: false
        }
    ]
}

// 原始版本
const getOriginalVersion = (record: any) => {
    const versions = getVersions(record)
    return versions[0]
}

// 最新版本
const getLatestVersion = (record: any) => {
    const versions = getVersions(record)
    const latest = versions.find((v: any) => v.is_latest)
    return latest || versions[versions.length - 1]
}

// 其他版本（排除原始和最新）
const getOtherVersions = (record: any) => {
    const versions = getVersions(record)
    const originalId = getOriginalVersion(record).id
    const latestId = getLatestVersion(record).id
    return versions.filter((v: any) => v.id !== originalId && v.id !== latestId)
}

// 加载其他模板（走接口，接口不通时用档案自带 versions 兜底）
const loadOtherTemplates = (record: any) => {
    let requestParam = {
        url: '/admin/v1/templateZip/otherTemplates',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            type: record.type
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            otherTemplates.value = res.data.list || []
        })
        .catch(() => {
            // 兜底：用档案自带 versions 当模板（第 2 版之后）
            const versions = getVersions(record)
            otherTemplates.value = versions.slice(1).map((v: any) => ({
                id: v.id,
                template_code: 'V' + v.version,
                name: v.name,
                category: record.type_name,
                updated_at: v.created_at
            }))
        })
}

// 可搜索过滤：名称或编号匹配
const filterTemplateOption = (input: string, option: any) => {
    const label = (option.label || '').toString().toLowerCase()
    return label.indexOf(input.toLowerCase()) > -1
}

// 切换版本类型时处理
const onVersionTypeChange = (record: any) => {
    if (leaseData.versionType === 'other') {
        loadOtherTemplates(record)
        leaseData.templateId = null
    } else {
        leaseData.templateId = null
    }
}

// 根据选择算出最终下载的版本 id
const getSelectedVersionId = (record: any) => {
    if (leaseData.versionType === 'original') {
        return getOriginalVersion(record).id
    }
    if (leaseData.versionType === 'latest') {
        return getLatestVersion(record).id
    }
    // other：用选中的模板 id
    return leaseData.templateId
}

const openLeaseChange = (e, record) => {
    // 每次打开重置版本选择
    leaseData.versionType = 'original'
    leaseData.templateId = null
    otherTemplates.value = []

    // 只切换公司时清空金额、租期、签约日期
    if (leaseData.last_company_id != props.tableColumnsData.id) {
        leaseData.zujin =
            props.tableColumnsData.xflxr_xf_price == 0 ? 300 : props.tableColumnsData.xflxr_xf_price
        leaseData.zqrange = ''
        leaseData.zqrangea = null
        leaseData.zqrangeb = null
        leaseData.is_diy = 2
        leaseData.hetong_sign_date = dayjs(dayjs().format('YYYY-MM-DD'), 'YYYY-MM-DD')
    }
    leaseData.last_company_id = props.tableColumnsData.id
}

const changzq = () => {
    if (leaseData.is_diy == 1) {
        if (leaseData.zqrangea) {
            leaseData.hetong_sign_date = leaseData.zqrangea
        }
    } else {
        let arr = leaseData.zqrange.split('~')
        leaseData.hetong_sign_date = dayjs(arr[0], 'YYYY-MM-DD')
    }
}

const changeLeaseGz = () => {
    if (leaseData.gz == 2) {
        leaseData.qz = 2
    }
}

// 下载原始版本（带参数配置 + 版本选择）
const downLeaseLease = (record) => {
    if (!leaseData.reason) {
        message.warn('请选择理由')
        return
    }
    // 校验版本
    if (leaseData.versionType === 'other' && !leaseData.templateId) {
        message.warn('请选择其他模板')
        return
    }
    const versionId = getSelectedVersionId(record)
    if (!versionId) {
        message.warn('未找到对应版本/模板')
        return
    }

    let zq = ''
    if (leaseData.is_diy == 1) {
        if (!leaseData.zqrangea || !leaseData.zqrangeb) {
            message.warn('请选择租期')
            return
        }
        zq =
            dayjs(leaseData.zqrangea).format('YYYY-MM-DD') +
            '~' +
            dayjs(leaseData.zqrangeb).format('YYYY-MM-DD')
    } else {
        if (!leaseData.zqrange) {
            message.warn('请选择租期')
            return
        }
        zq = leaseData.zqrange
    }

    const downItem = {
        'url': '',
        'children': []
    }
    let attach = ''
    let downurl = 'https://console.cskaiyela.com/hncskaiyela/admin/v1/templateZipAdd?sourcezipid=' + record.id + '&customer_id=' + props.tableColumnsData.id //直接去转换的
    //租赁合同
    downItem.url = downurl + '&async=1&type=4'
    attach =
        '&gz=' +
        leaseData.gz +
        '&qz=' +
        leaseData.qz +
        '&zd=' +
        leaseData.zd +
        '&tel=' +
        leaseData.tel +
        '&zujin=' +
        leaseData.zujin +
        '&fee_standard=' +
        leaseData.fee_standard +
        '&zq=' +
        zq +
        '&reason=' +
        leaseData.reason +
        '&hetong_sign_date=' +
        leaseData.hetong_sign_date
    emit('callFatherDownLease', downItem, attach)
}

/* ==================== 档案相关方法 ==================== */

onMounted(() => {
    queryDetail()
})

const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})

// 切换 tab 时加载仓库数据
watch(() => state.activeTab, (val) => {
    if (val === 'warehouse') queryWarehouse()
})

// 打开添加备注弹窗
const handleAddRemark = (record) => {
    remarkForm.remark = ''
    remarkForm.id = record.id
    state.remarkModalOpen = true
}

// 提交备注
const handleRemarkOk = () => {
    if (!remarkForm.remark.trim()) {
        message.warning('请输入备注内容')
        return
    }
    let requestParam = {
        url: '/admin/v1/templateZip/addRemark',
        method: 'post',
        data: {
            id: remarkForm.id,
            remark: remarkForm.remark
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '备注添加成功')
            state.remarkModalOpen = false
            queryDetail()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const handleDelete = (record) => {
    let requestParam = {
        url: '/admin/v1/templateZip/' + record.id,
        method: 'delete'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            queryDetail()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const queryDetail = () => {
    state.ownershipTableLoading = true
    let requestParam = {
        url: '/admin/v1/templateZipList',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            limit: 'all',
            recycle: state.recycle,
            is_formal: state.is_formal
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            shareOwnership.value = res.data.list
            // 构造租期列表（使用客户行数据）
            zqlist.value = buildZqlist(props.tableColumnsData)
            state.ownershipTableLoading = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

const cancel = () => {
    emit('cancel')
}

const handleRecord = () => {
    state.createOpen = true
}

const handleDownload = () => {
    state.downZcLoading = true
    let requestParam = {
        url: '/admin/v1/customerDownZc?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            state.downZcLoading = false
            message.success(res.msg ? res.msg : '获取成功')
            queryDetail()
        })
        .catch((res) => {
            state.downZcLoading = false
            message.error(res.msg ? res.msg : '获取失败')
        })
}

const createOk = () => {
    createFormRef.value.validate().then(() => {
        let requestParam = {
            url: '/admin/v1//templateZipAppend',
            method: 'post',
            data: Object.assign({ customer_id: props.tableColumnsData.id }, createForm)
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg ? res.msg : '添加成功')
                state.createOpen = false
                const keys = Object.keys(createForm)
                let obj: { [name: string]: any } = {}
                keys.forEach((item) => {
                    obj[item] = null
                })
                Object.assign(createForm, obj)
                queryDetail()
            })
            .catch((res) => {
                message.error(res.msg ? res.msg : '添加失败')
            })
    })
}

// 进度截图
let timer = ref()
const qrcodeCancel = () => {
    state.openQrcode = false
    clearInterval(timer.value)
}
const registerFormState = reactive<any>({
    code: null,
    name: '',
    id_card_number: null,
    phone_number: null,
    type: 1,
    id: null
})
const finalScreen = () => {
    qrcodeCancel()
    state.screenshotLoading = true
    let requestParam = {
        url: '/admin/v1/templateZipscreenshot',
        method: 'post',
        data: { customer_id: props.tableColumnsData.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '截图中')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '截图失败')
        })
        .finally(() => {
            state.screenshotLoading = false
        })
}
const handleScreenshot = () => {
    if (props.tableColumnsData.business_type == 1) {
        finalScreen()
    } else {
        if (props.tableColumnsData.business_type == 3) {
            registerFormState.type = 2
        }
        getMigrateSmsCode()
        let param = {
            url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
            method: 'get'
        }
        baseService(param)
            .then((res: any) => {
                state.openQrcode = true
                if (res.data.status == 1) {
                    finalScreen()
                } else if (registerFormState.type == 2) {
                    let queryParam = {
                        url: '/admin/v1/getAlterationQrcodeUrl?customer_id=' + props.tableColumnsData.id,
                        method: 'get'
                    }
                    baseService(queryParam)
                        .then((res: any) => {
                            timer.value = setInterval(() => {
                                let param = {
                                    url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
                                    method: 'get'
                                }
                                baseService(param).then((res: any) => {
                                    if (res.data.status == 1) {
                                        finalScreen()
                                    }
                                })
                            }, 3000)
                            state.openQrcode = true
                            state.deadline = Date.now() + 1000 * 120
                            state.qrcode = res.data.base64_image
                        })
                        .catch((res) => {
                            if (res.msg) {
                                message.error(res.msg)
                            } else {
                                message.error('操作失败')
                            }
                        })
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    }
}
const rules = {}
const onGetCodeClick = () => {
    state.getCodeDisabled = true
    let requestParam = {
        url:
            '/admin/v1/getMigrateSmsCode?id_card_number=' +
            registerFormState.id_card_number +
            '&social_credit_code=' +
            registerFormState.social_credit_code +
            '&customer_id=' +
            props.tableColumnsData.id +
            '&phone_number=' +
            registerFormState.phone_number +
            '&name=' +
            registerFormState.name,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.name = res.data.liaisonName
            registerFormState.phone_number = res.data.tel
            message.success(res.msg)
        })
        .catch((res) => {
            state.getCodeDisabled = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}
const onStatisticFinish = () => {
    state.qrcode = ''
    state.deadline = 0
}
const onRegisterFinish = () => {
    if (!registerFormState.code) {
        message.error('请输入验证码')
        return
    }
    let requestParam = {
        url: '/admin/v1/setMigrateSmsCode',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            verify_code: registerFormState.code,
            name: registerFormState.name,
            phone_number: registerFormState.phone_number,
            id_card_number: registerFormState.id_card_number,
            social_credit_code: registerFormState.social_credit_code
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            finalScreen()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const getMigrateSmsCode = () => {
    let requestParam = {
        url: '/admin/v1/getLiaisonInfo?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.social_credit_code = props.tableColumnsData.social_credit_code
            registerFormState.id = res.data.id
            registerFormState.name = res.data.name
            registerFormState.id_card_number = res.data.id_card_number
            registerFormState.phone_number = res.data.phone_number
            if (res.data.is_change) {
                message.warn('检测到联络员有变化,正在重新刷新列表')
                queryDetail()
            }
        })
        .catch((res) => { })
}
const handleTuiS = (record) => {
    const hide = message.loading({
        content: '推送中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: '/admin/v1/pushZipMessage?zip_id=' + record.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '推送失败')
        })
}

/* ==================== 仓库相关方法 ==================== */

// 查询仓库列表
const queryWarehouse = () => {
    /*
    state.warehouseLoading = true
    let requestParam = {
        url: '/admin/v1/warehouseList',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            status: state.warehouseStatus
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            warehouseList.value = res.data.list
            state.selectedRowKeys = []
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '操作失败')
        })
        .finally(() => {
            state.warehouseLoading = false
        })
            */
}

// 表格多选
const onSelectChange = (keys: number[]) => {
    state.selectedRowKeys = keys
}

// 打开入库弹窗
const handleInOpen = () => {
    Object.assign(inForm, {
        goods_name: '',
        storage_location: '',
        storage_code: '',
        remark: ''
    })
    state.inOpen = true
}

// 入库提交
const inOk = () => {
    inFormRef.value.validate().then(() => {
        let requestParam = {
            url: '/admin/v1/warehouseIn',
            method: 'post',
            data: { customer_id: props.tableColumnsData.id, ...inForm }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg ? res.msg : '入库成功')
                state.inOpen = false
                queryWarehouse()
            })
            .catch((res) => {
                message.error(res.msg ? res.msg : '入库失败')
            })
    })
}

// 单条出库
const handleOut = (record: any) => {
    outForm.ids = [record.id]
    outForm.out_remark = ''
    state.outGoodsNames = record.goods_name
    state.outOpen = true
}

// 批量出库
const handleBatchOut = () => {
    const names = warehouseList.value
        .filter((item: any) => state.selectedRowKeys.includes(item.id))
        .map((item: any) => item.goods_name)
        .join('、')
    outForm.ids = [...state.selectedRowKeys]
    outForm.out_remark = ''
    state.outGoodsNames = names
    state.outOpen = true
}

// 出库提交
const outOk = () => {
    let requestParam = {
        url: '/admin/v1/warehouseOut',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            ids: outForm.ids,
            out_remark: outForm.out_remark
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '出库成功')
            state.outOpen = false
            state.selectedRowKeys = []
            queryWarehouse()
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '出库失败')
        })
}

// 删除仓库记录
const handleWarehouseDelete = (record: any) => {
    let requestParam = {
        url: '/admin/v1/warehouse/' + record.id,
        method: 'delete'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '删除成功')
            queryWarehouse()
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '删除失败')
        })
}
//直接取走
const handleDirectTakeInit = (e) => {
    state.shelf_code = '加载中...'
    if (e) {
        let requestParam = {
            url: '/admin/v1/directTakeInit',
            method: 'post',
            data: {
                customer_id: props.tableColumnsData.id,
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                state.shelf_code = res.data.shelf_code
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败,请联系管理员')
                }
            })
    }
}
const handleDirectTake = () => {
    let requestParam = {
        url: '/admin/v1/directTake',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
</script>

<style lang="less" scoped>
.d-flex {
    justify-content: space-between;
    align-items: center;
}

.image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
</style>
